// import Link from 'next/link';
import classnames from 'classnames';

const SorraButton = ({ children, className, disabled, ...restProps }) => {
  return (
    <button
      className={classnames(
        'rounded-lg bg-sorra-pink px-4 py-2 text-xs font-bold text-white hover:opacity-70 disabled:pointer-events-none disabled:bg-[#FCD6DB]',
        className
      )}
      {...restProps}
      disabled={disabled}
    >
      {children}
    </button>
  );
  // return isLink ?
  //     (
  //         <Link
  //             className={classnames('text-xs font-bold px-4 py-2 rounded-lg bg-sorra-pink text-white hover:opacity-70 disabled:pointer-events-none disabled:bg-gray-100', className)}
  //             {...restProps}
  //         >
  //             {children}
  //         </Link>
  //     ) : (
  //         <button
  //             className={classnames('text-xs font-bold px-4 py-2 rounded-lg bg-sorra-pink text-white hover:opacity-70 disabled:pointer-events-none disabled:bg-gray-100', className)}
  //             {...restProps}
  //         >
  //             {children}
  //         </button>
  //     )
};

export default SorraButton;
